const CARD_TYPES = [
    {
        name: 'visa',
        label: 'Visa',
        paymentMethod: 5,
        regex: /^4[0-9]{12}(?:[0-9]{3})?$/,
    },
    {
        name: 'mastercard',
        label: 'MasterCard',
        paymentMethod: 4,
        regex: /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
    },
    {
        name: 'amex',
        label: 'American Express',
        paymentMethod: 6,
        regex: /^3[47][0-9]{13}$/,
    },
    {
        name: 'discover',
        label: 'Discover',
        paymentMethod: 3,
        regex: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
    },
]

function detectCardType(cardNumber) {
    for (let i = 0; i < CARD_TYPES.length; i++) {
        if (CARD_TYPES[i].regex.test(cardNumber)) {
            return CARD_TYPES[i];
        }
    }
    return null;
}

export {
    CARD_TYPES,
    detectCardType,
}


// WEBPACK FOOTER //
// ./src/components/billing-form/constants/cardTypes.js